import Icon from '../Icon.vue'

Icon.register({
  'youtube_channel': {
    width: 16,
    height: 12,
    paths: [
      {
        d: 'M14.456.796c.237.233.409.524.498.844h-.002c.32 1.17.32 4.36.32 4.36s0 3.191-.32 4.361a1.896 1.896 0 01-1.35 1.326C12.411 12 7.635 12 7.635 12s-4.775 0-5.965-.313A1.897 1.897 0 01.32 10.36C0 9.19 0 6 0 6s0-3.19.32-4.36A1.897 1.897 0 011.67.314C2.861 0 7.635 0 7.635 0s4.776 0 5.969.313c.322.084.615.25.852.483zM10.91 6L6.545 3.273v5.454L10.91 6z'
      }
    ]
  }
})
